import React from "react";
import { X, Check } from "lucide-react";
import { whyChoose } from "../../mock";
import Reveal from "../Reveal";

export default function WhyChoose() {
  return (
    <section className="bg-gold-soft/40 py-20">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <Reveal className="max-w-3xl">
          <h2 className="font-display text-3xl sm:text-4xl text-ink">{whyChoose.title}</h2>
          <p className="mt-4 text-lg text-muted-foreground leading-relaxed">{whyChoose.intro}</p>
        </Reveal>

        <div className="mt-10 grid grid-cols-1 md:grid-cols-2 gap-6">
          <Reveal>
            <div className="h-full rounded-2xl border border-gold/15 bg-white p-7">
              <span className="inline-block rounded-full bg-ink/5 px-4 py-1.5 text-xs font-semibold uppercase tracking-widest text-muted-foreground">
                {whyChoose.typical.label}
              </span>
              <ul className="mt-5 space-y-3.5">
                {whyChoose.typical.items.map((it) => (
                  <li key={it} className="flex items-center gap-3 text-[15px] text-muted-foreground">
                    <span className="grid place-items-center h-6 w-6 rounded-full bg-red-50 text-red-400 shrink-0">
                      <X size={14} />
                    </span>
                    {it}
                  </li>
                ))}
              </ul>
            </div>
          </Reveal>

          <Reveal delay={100}>
            <div className="h-full rounded-2xl border-2 border-gold bg-white p-7 shadow-[0_16px_40px_rgba(201,162,74,0.18)]">
              <span className="inline-block rounded-full bg-gold px-4 py-1.5 text-xs font-semibold uppercase tracking-widest text-ink">
                {whyChoose.elite.label}
              </span>
              <ul className="mt-5 space-y-3.5">
                {whyChoose.elite.items.map((it) => (
                  <li key={it} className="flex items-center gap-3 text-[15px] font-medium text-ink">
                    <span className="grid place-items-center h-6 w-6 rounded-full bg-gold/20 text-gold-dark shrink-0">
                      <Check size={14} />
                    </span>
                    {it}
                  </li>
                ))}
              </ul>
            </div>
          </Reveal>
        </div>
      </div>
    </section>
  );
}
